export default __webpack_public_path__ + "static/media/pothos.632ac843.jpg";